import React, { useEffect, useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import { Marker } from "react-native-maps";
import Text from "@components/CustomText";
import MapMarker from "@assets/svg/MapMarker";

const INDIGO = "#4F46E5";
const WHITE = "#FFFFFF";
const BORDER = "#E2E8F0";
const SLATE = "#475569";

// See DbMarker.js for why collapsable={false} + the brief tracking window
// are required for custom-view markers to draw on Android.
const HubMarker = ({ hub }) => {
  const markerRef = useRef(null);
  const [track, setTrack] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setTrack(false), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <Marker
      ref={markerRef}
      coordinate={{ latitude: Number(hub.lat), longitude: Number(hub.lng) }}
      anchor={{ x: 0.5, y: 0.5 }}
      tracksViewChanges={track}
      tracksInfoWindowChanges={false}
      zIndex={10}
    >
      <View collapsable={false} style={styles.wrap}>
        <View style={styles.circle}>
          <MapMarker width={10} height={10} />
        </View>
        <View style={styles.labelPill}>
          <Text style={styles.label} numberOfLines={1}>
            HUB
          </Text>
        </View>
      </View>
    </Marker>
  );
};

export default HubMarker;

const styles = StyleSheet.create({
  wrap: {
    alignItems: "center",
    maxWidth: 160,
  },
  circle: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: INDIGO,
    borderWidth: 1,
    borderColor: WHITE,
    alignItems: "center",
    justifyContent: "center",
    elevation: 2,
  },
  labelPill: {
    marginTop: 2,
    backgroundColor: WHITE,
    borderRadius: 6,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: BORDER,
    paddingHorizontal: 4,
    paddingVertical: 1,
  },
  label: {
    color: SLATE,
    fontSize: 7,
    fontWeight: "700",
    letterSpacing: 0.4,
  },
});
